import React, { useState } from 'react';
import { Checkbox, Typography } from 'antd';
import { useHistory } from 'react-router';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Title } from '~/components';
import paths from '~/pages/paths';
import KsaTooltips from '~/pages/ksa/dataValidation/components/KsaTooltips';
import { useGetInvitationName, useValidateInvitation } from '~/controllers/invitation';
import { ConfirmButton } from '~/layouts/ksa/CompanyInfoLayout';

const Invitation: React.FC = () => {
  const history = useHistory();
  const [isAgreed, setIsAgreed] = useState(false);
  const [isTooltipVisible, setTooltipVisible] = useState(false);
  const { t } = useTranslation('ksaOnboarding');
  const { t: tc } = useTranslation('common');
  const validateInvitation = useValidateInvitation();

  const onContinueClick = () => {
    if (!isAgreed) {
      setTooltipVisible(true);
      return;
    }

    validateInvitation
      .mutateAsync()
      .then((res) => {
        history.push(
          paths.ksa.invitation.smsotp.replace(':smsOtpChallengeId', res.smsOtpChallengeId)
        );
      })
      .catch(() => {
        history.push(paths.ksa.invitation.error.replace(':errorType', 'default'));
      });
  };

  const onAgreeClick: React.MouseEventHandler<HTMLInputElement> = () => {
    setIsAgreed((prevState) => !prevState);
    setTooltipVisible(false);
  };

  const { data: name } = useGetInvitationName();
  return (
    <>
      <div>
        <Title text={t('Get started')} subtext={t('with {{BRANDING_NAME}}')} />
        <SubTitle>
          {name ? t('Hello, {{name}}!', { name }) : t('Hello!')}
          <br />
          <br />
          {t(
            'You have been invited to on-boarding application. Please click ‘Continue’ button and we will send you an OTP to ensure your privacy.'
          )}
        </SubTitle>

        <ConfirmButton
          id="dataValidationForm_submit"
          type="primary"
          htmlType="submit"
          loading={validateInvitation.isLoading}
          onClick={onContinueClick}
        >
          {tc('Confirm')}
        </ConfirmButton>
      </div>

      <div>
        {isTooltipVisible && (
          <KsaTooltips>
            {t('Required confirmation to the Terms and Conditions and Privacy Policy')}
          </KsaTooltips>
        )}
        <CheckboxItem onClick={onAgreeClick}>
          <Trans
            t={t}
            i18nKey="I agree to the <1>Terms and Conditions</1> and <3>Privacy Policy</3>"
          >
            {'I agree to the '}
            <a
              href="https://www.network.ae/en/contents/view/terms-condition"
              target="_blank"
              rel="noreferrer"
            >
              Terms and Conditions
            </a>
            {' and '}
            <a
              href="https://www.network.ae/en/contents/view/privacy-notice"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </Trans>
        </CheckboxItem>
      </div>
    </>
  );
};

const CheckboxItem = styled(Checkbox as any)`
  .ant-checkbox-inner {
    border-radius: 2px !important;
  }
`;

const SubTitle = styled(Typography.Paragraph)`
  margin-bottom: 32px !important;
`;

export default Invitation;
